// extracted by mini-css-extract-plugin
module.exports = {"root":"Radio_root__2eT7v","label":"Radio_label__3wP53","checkMark":"Radio_checkMark__3_n5N","disabled":"Radio_disabled__1MUpP"};